export default __webpack_public_path__ + "static/media/T564MANL2.72d2141f.pdf";